<script setup lang="ts">
import { useDynamicIcons } from '~layers/shared/utils/useDynamicIcons.ts'

const { slice } = defineProps({
  slice: {
    type: Object,
    required: true,
  },
  index: {
    type: Number,
    required: true,
  },
})

// const sliceElm = useTemplateRef('sliceElm')
// const isVisibleNow = ref(false)
// const hasBeenVisible = ref(false)

const sliceClasses = computed(() => {
  return [
    `content-type--${slice?.Settings?.SliceWidth?.toLowerCase()?.replace('_', '-') || 'layout-width'}`,
    {
      // 'content-type--visible': isVisibleNow.value,
      // 'content-type--has-been-visible': hasBeenVisible.value,
      // 'content-type--has-background': slice?.Settings?.BackgroundColor,
      'content-type--handwritten-caps': slice?.Settings?.TitleStyle === 'Handwritten_All_Caps',
      'content-type--caps-handwritten': slice?.Settings?.TitleStyle === 'All_Caps_Handwritten',
    },
  ]
})

const sliceStyle = computed(() => {
  return {
    '--slice-color': slice?.Settings?.BackgroundColor || '#fff',
    '--contrast-color': useContrastColor((slice?.Settings?.BackgroundColor || '#fff'), '#fff', '#282827'),
  }
})

const { loadIcon } = useDynamicIcons()

// onMounted(() => {
//   if (!sliceElm.value) return

//   const observer = new IntersectionObserver(
//     ([entry]) => {
//       if (entry?.isIntersecting) {
//         isVisibleNow.value = true
//         hasBeenVisible.value = true

//       } else {
//         isVisibleNow.value = false
//       }
//     },
//     {
//       threshold: 0,
//       rootMargin: '0px 0px 0px 0px'
//     }
//   )

//   observer.observe(sliceElm.value)

//   // Cleanup observer on unmount
//   onUnmounted(() => {
//     observer.disconnect()
//   })
// })
</script>

<template>
  <section
    :id="slice?.Settings?.AnchorId || `slice-${index}`"
    ref="sliceElm"
    class="content-type"
    :class="sliceClasses"
    :style="sliceStyle"
  >
    <div class="content-type__container">
      <div
        v-if="slice?.Settings?.Title || slice?.Settings?.Title2"
        class="content-type__heading"
      >
        <div
          v-if="slice?.Settings?.Title"
          class="content-type__heading--1"
        >
          {{ slice.Settings.Title }}
        </div>

        <div
          v-if="slice?.Settings?.Title2"
          class="content-type__heading--2"
        >
          {{ slice.Settings.Title2 }}
        </div>
      </div>

      <div class="content-type__content">
        <slot />
      </div>

      <p
        v-if="slice?.Settings?.Description"
        class="content-type__description"
      >
        {{ slice.Settings.Description }}
      </p>

      <AppLink
        v-if="slice?.Settings?.Button?.Text && slice?.Settings?.Button?.Link"
        :to="slice?.Settings?.Button?.Link"
        class="content-type__button"
        :class="`content-type__button--${slice?.Settings?.Button?.Type} ${slice?.Settings?.Button?.Small ? 'content-type__button--small' : ''}`"
      >
        <Icon
          v-if="slice?.Settings?.Button?.IconLeft"
          :name="loadIcon(slice.Settings.Button.IconLeft)"
          :class="`icon:${slice.Settings.Button.IconLeft.toLowerCase()}`"
        />
        <span>{{ slice?.Settings?.Button?.Text }}</span>
        <Icon
          v-if="slice?.Settings?.Button?.IconRight"
          :name="loadIcon(slice.Settings.Button.IconRight)"
          :class="`icon:${slice.Settings.Button.IconRight.toLowerCase()}`"
        />
      </AppLink>
    </div>
  </section>
</template>

<style>
@import url("~layers/app/components/Strapi/Slice.css");
</style>
